import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { useAuth } from "./AuthContext";
import {
  addCartItem,
  getCart,
  removeCartItem,
  setCartItemQuantity,
} from "../lib/firestoreCart";

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const { user } = useAuth();
  const [cart, setCart] = useState({ items: [], total: 0 });

  const refresh = useCallback(async () => {
    if (!user) {
      setCart({ items: [], total: 0 });
      return;
    }
    try {
      setCart(await getCart(user.id));
    } catch {
      setCart({ items: [], total: 0 });
    }
  }, [user]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const addItem = async (product_id, quantity = 1) => {
    if (!user) return { ok: false, error: "Please sign in first" };
    await addCartItem(user.id, product_id, quantity);
    await refresh();
    return { ok: true };
  };

  const removeItem = async (product_id) => {
    if (!user) return;
    await removeCartItem(user.id, product_id);
    await refresh();
  };

  const updateQty = async (product_id, quantity) => {
    if (!user) return;
    await setCartItemQuantity(user.id, product_id, quantity);
    await refresh();
  };

  const count = cart.items.reduce((s, i) => s + i.quantity, 0);

  return (
    <CartContext.Provider value={{ cart, count, addItem, removeItem, updateQty, refresh }}>
      {children}
    </CartContext.Provider>
  );
}

export function useCart() {
  return useContext(CartContext);
}
